<template>
  <div data-testid="cycle-switcher-dropdown" class="fc-cycle-switcher">
    <div data-testid="cycle-switcher-dropdown__search" class="fc-cycle-switcher__search">
      <v-text-field
        data-testid="cycle-switcher-dropdown__search-input"
        v-model="search"
        dense
        hide-details
        clearable
        outlined
        placeholder="Search cycles"
        prepend-inner-icon="mdi-magnify"
      />
    </div>
    <div data-testid="cycle-switcher-dropdown__list" class="fc-cycle-switcher__list">
      <div
        v-if="loading"
        data-testid="cycle-switcher-dropdown__loading"
        class="fc-cycle-switcher__loading"
      >
        Loading cycles…
      </div>
      <template v-else>
        <div
          v-for="(cycle, index) in filteredCycles"
          :key="cycle._id || index"
          :data-testid="`cycle-switcher-dropdown__row--${index}`"
          class="fc-cycle-switcher__row"
          :class="{ 'fc-cycle-switcher__row--active': cycle._id === activeCycleId }"
          role="button"
          tabindex="0"
          @click="selectCycle(cycle)"
          @keyup.enter="selectCycle(cycle)"
        >
          <span class="fc-cycle-switcher__row-label">{{ getLabel(cycle) }}</span>
          <v-icon
            v-if="cycle._id === activeCycleId"
            class="fc-cycle-switcher__row-check"
            small
            color="primary"
          >mdi-check</v-icon>
        </div>
        <div
          v-if="!filteredCycles.length"
          data-testid="cycle-switcher-dropdown__empty"
          class="fc-cycle-switcher__empty"
        >
          No cycles match your search
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getCycleBreadcrumbLabel,
  sortCyclesByEndDateDesc
} from './financialCloseTopNavUtils';

export default {
  name: 'CycleSwitcherDropdown',
  props: {
    cycles: { type: Array, default: () => [] },
    activeCycleId: { type: String, default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ['cycle-selected'],
  data() {
    return {
      search: ''
    };
  },
  computed: {
    /** All accessible cycles, end date desc */
    sortedCycles() {
      return sortCyclesByEndDateDesc(this.cycles || []);
    },
    filteredCycles() {
      const q = (this.search || '').trim().toLowerCase();
      if (!q) return this.sortedCycles;
      return this.sortedCycles.filter((cycle) => {
        const label = this.getLabel(cycle).toLowerCase();
        return label.includes(q);
      });
    }
  },
  methods: {
    getLabel(cycle) {
      return getCycleBreadcrumbLabel(cycle);
    },
    selectCycle(cycle) {
      if (!cycle?._id) return;
      this.$emit('cycle-selected', cycle);
    }
  },
  beforeDestroy() {
    this.search = '';
  }
};
</script>
